module.exports = __webpack_public_path__ + "static/media/avatar.d877b1dc.svg";